import { DEFAULT_MAP_ID } from "config/constants";
import { MapID, premiumMapIds } from "config/enums/mapIDs";

/**
 * The map that's shown: a premium map only with the premium features, the default map without them (also while
 * it isn't known yet whether the user has them)
 */
export const getShownMapId = (
  mapId: MapID,
  allowPremiumFeatures: boolean | undefined
) =>
  premiumMapIds.has(mapId) && !allowPremiumFeatures ? DEFAULT_MAP_ID : mapId;
